import styled from 'styled-components';

import LayoutIcon from 'common/icons/LayoutIcon';
import ChevronDown from 'common/icons/ChevronDown';

import { containerPaddingS, baseBorderRadius } from 'common/styles/variables';

export const LayoutOptionStyled = styled.div`
    border: 1px solid ${({ theme }) => theme.palette.grayscale.gray10};
    border-radius: 100px;
    padding-left: ${containerPaddingS};

    &:hover,
    &:active {
        color: ${({ theme }) => theme.palette.primary.main};
        border-color: ${({ theme }) => theme.palette.primary.main};
    }
`;

export const LayoutIconStyled = styled(LayoutIcon)`
    height: 19px;

    &:hover,
    &:focus {
        color: ${({ theme }) => theme.palette.primary.main};
    }
`;

export const LayoutArrow = styled(ChevronDown)`
    &:hover,
    &:focus {
        color: ${({ theme }) => theme.palette.primary.main};
    }
`;

export const StyledIconDiv = styled.div`
    &:hover,
    &:focus {
        outline: 0;
        color: ${({ theme }) => theme.palette.primary.main};
        border-color: ${({ theme }) => theme.palette.primary.main};
    }
`;

export const LayoutIconCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    border: 1px solid ${({ theme }) => theme.palette.grayscale.gray10};
    border-radius: ${baseBorderRadius};
    height: 80px;
    width: 125px;

    svg {
        color: ${({ theme }) => theme.palette.grayscale.gray10};
    }

    &:hover {
        border: 1px solid ${({ theme }) => theme.palette.primary.main};

        svg {
            color: ${({ theme }) => theme.palette.primary.main};
        }
    }
`;

export const IconContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;
